import { Link } from "react-router-dom";
import { BrandMark } from "./Logo";

export default function Footer() {
  return (
    <footer data-testid="site-footer" className="border-t border-slate-200 py-8 mt-auto">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 flex flex-col sm:flex-row items-center justify-between gap-4 text-sm text-slate-500">
        <div className="flex items-center gap-2">
          <BrandMark className="h-7 w-7" textClass="text-sm" />
          <div className="leading-tight">
            <span className="font-display font-semibold text-slate-900 block">Facio Doc</span>
            <span className="text-[10px] text-slate-400">by Matambanadzo Studio</span>
          </div>
        </div>
        <p>© 2026 Matambanadzo Studio — Facio Doc. Pay-as-you-go.</p>
        <div className="flex items-center gap-4">
          <Link to="/pricing" data-testid="footer-pricing" className="hover:text-indigo-600">Pricing</Link>
          <Link to="/terms" data-testid="footer-terms" className="hover:text-indigo-600">Terms</Link>
          <Link to="/privacy" data-testid="footer-privacy" className="hover:text-indigo-600">Privacy</Link>
        </div>
      </div>
    </footer>
  );
}
